"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CrosstabTable = _interopRequireDefault(require("./CrosstabTable.js"));
var _CrosstabSummaryTable = _interopRequireDefault(require("./CrosstabSummaryTable.js"));
var _cccisdVisualize = require("cccisd-visualize");
var _color = _interopRequireDefault(require("color"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Content = function Content(props) {
  var currentMetric = props.currentMetric,
    currentCrossMetric = props.currentCrossMetric,
    data = props.data,
    currentMetricSettings = props.currentMetricSettings;
  var _useMemo = (0, _react.useMemo)(function () {
      var allowRollup = currentMetricSettings.chartType !== 'none';
      var rollupThreshold = allowRollup && currentMetricSettings.enableRollupThreshold ? currentMetricSettings.rollupThresholdValue : 0;
      var metricCoding = currentMetric.enumCoding ? Object.entries(currentMetric.enumCoding).reduce(function (obj, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        obj[value] = key;
        return obj;
      }, {}) : null;
      var crossMetricCoding = currentCrossMetric.enumCoding ? Object.entries(currentCrossMetric.enumCoding).reduce(function (obj, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        obj[value] = key;
        return obj;
      }, {}) : null;
      var columns = data.crosstabSummaryStats.filter(function (item) {
        return item.value;
      }).map(function (item) {
        return {
          code: item.value,
          total: item.valueCount,
          label: crossMetricCoding[item.value]
        };
      });
      if (rollupThreshold > 0 && columns.length > rollupThreshold + 1) {
        columns.sort(function (a, b) {
          if (b.total !== a.total) {
            return b.total - a.total;
          }
          if (typeof a.label === 'string' && typeof b.label === 'string') {
            return a.label.localeCompare(b.label);
          }
          return 0;
        });
        var otherTotal = columns.length - rollupThreshold;
        var otherColumn = columns.slice(rollupThreshold).reduce(function (obj, row) {
          obj.total += row.total;
          return obj;
        }, {
          code: 'others',
          label: "".concat(otherTotal, " others"),
          total: 0,
          isOthers: true
        });
        columns = columns.slice(0, rollupThreshold);
        columns.push(otherColumn);
      }
      var rows = data.frequency.filter(function (item) {
        return item.value && item.frequency;
      }).map(function (item) {
        var values = item.frequency.reduce(function (obj, item1) {
          obj[item1.value] = item1.valueCount;
          return obj;
        }, {});
        return _objectSpread({
          total: Number(item.valueCount),
          label: currentMetric.enumCoding ? metricCoding[item.value] : item.value,
          values: columns.map(function (column) {
            var value = values[column.code];
            if (value) {
              delete values[column.code];
              return value;
            }
            if (column.isOthers) {
              return Object.values(values).reduce(function (sum, num) {
                return sum + num;
              }, 0);
            }
            return 0;
          })
        }, currentMetric.enumCoding ? {
          code: item.value
        } : {});
      });
      var crosstab = function (_currentMetric$conten) {
        var result = {
          columns: columns,
          rows: _toConsumableArray(rows)
        };
        if (currentMetric.enumCoding) {
          var existingLabels = result.rows.reduce(function (obj, item) {
            obj.add(item.label);
            return obj;
          }, new Set());
          for (var _i = 0, _Object$entries = Object.entries(currentMetric.enumCoding); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              label = _Object$entries$_i[0],
              code = _Object$entries$_i[1];
            if (!existingLabels.has(label)) {
              result.rows.push({
                total: 0,
                label: label,
                code: code,
                values: columns.map(function (_) {
                  return 0;
                })
              });
            }
          }
        }
        if (rollupThreshold > 0 && result.rows.length > rollupThreshold + 1) {
          result.rows.sort(function (a, b) {
            if (b.total !== a.total) {
              return b.total - a.total;
            }
            if (typeof a.label === 'string' && typeof b.label === 'string') {
              return a.label.localeCompare(b.label);
            }
            return 0;
          });
          var _otherTotal = result.rows.length - rollupThreshold;
          var otherRow = result.rows.slice(rollupThreshold).reduce(function (obj, row) {
            obj.total += row.total;
            for (var i = 0; i < result.columns.length; i++) {
              obj.values[i] += row.values[i];
            }
            return obj;
          }, {
            label: "".concat(_otherTotal, " others"),
            total: 0,
            values: result.columns.map(function (_) {
              return 0;
            }),
            isOthers: true
          });
          result.rows = result.rows.slice(0, rollupThreshold);
          result.rows.push(otherRow);
        } else if ((_currentMetric$conten = currentMetric.content) !== null && _currentMetric$conten !== void 0 && _currentMetric$conten.enumDisplayText) {
          // Sort by enum order
          var order = currentMetric.content.enumDisplayText.reduce(function (obj, item, index) {
            obj[item] = index;
            return obj;
          }, {});
          result.rows.sort(function (a, b) {
            return order[a.label] - order[b.label];
          });
        }
        return result;
      }();

      // fix total, because total from DB includes null values
      var _iterator = _createForOfIteratorHelper(crosstab.rows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          row.total = row.values.reduce(function (sum, num) {
            return sum + num;
          }, 0);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      crosstab.rows = crosstab.rows.filter(function (item) {
        return item.total > 0;
      });
      var _loop = function _loop(i) {
        var column = crosstab.columns[i];
        column.total = crosstab.rows.reduce(function (sum, row) {
          return sum + row.values[i];
        }, 0);
      };
      for (var i = 0; i < crosstab.columns.length; i++) {
        _loop(i);
      }
      var summary = function () {
        if (!currentMetricSettings.showSummaryStats) {
          return [];
        }
        var stats = data.crosstabSummaryStats.filter(function (item) {
          return item.value;
        }).reduce(function (obj, item) {
          obj[item.value] = item;
          return obj;
        }, {});
        return {
          columns: columns,
          rows: [{
            label: 'Mean',
            key: 'avg'
          }, {
            label: 'Stddev',
            key: 'stddev'
          }, {
            label: 'Min',
            key: 'min'
          }, {
            label: 'Max',
            key: 'max'
          }].map(function (item) {
            return {
              label: item.label,
              values: crosstab.columns.filter(function (column) {
                return !column.isOthers;
              }).map(function (column) {
                return stats[column.code][item.key];
              }),
              total: data[item.key]
            };
          })
        };
      }();
      var chart = function () {
        if (currentMetricSettings.chartType === 'bar') {
          if (currentMetricSettings.visualizeAs === 'mean') {
            return data.crosstabSummaryStats.filter(function (item) {
              return item.value && item.avg !== null;
            }).map(function (item) {
              return {
                id: item.value,
                mean: item.avg
              };
            });
          }
          return crosstab.rows.map(function (row) {
            var obj = {
              label: row.label
            };
            for (var _i2 = 0; _i2 < crosstab.columns.length; _i2++) {
              var column = crosstab.columns[_i2];
              obj[column.label] = row.values[_i2];
            }
            return obj;
          });
        }
        if (currentMetricSettings.chartType === 'line') {
          if (currentMetricSettings.visualizeAs === 'mean') {
            return [{
              id: 'mean',
              data: data.crosstabSummaryStats.filter(function (item) {
                return item.avg !== null;
              }).map(function (item) {
                return {
                  x: item.value,
                  y: item.avg
                };
              })
            }];
          }
          return crosstab.rows.map(function (row) {
            return {
              id: row.label,
              data: columns.map(function (column, index) {
                return {
                  x: column.label,
                  y: row.values[index]
                };
              })
            };
          });
        }
        if (currentMetricSettings.visualizeAs === 'mean' && currentMetricSettings.chartType === 'bullet') {
          var means = data.crosstabSummaryStats.reduce(function (obj, item) {
            if (item.value) {
              obj[item.value] = item.avg;
            }
            return obj;
          }, {});
          var ranges = [0];
          if (currentMetricSettings.nivoOptions.bullet.ranges) {
            currentMetricSettings.nivoOptions.bullet.ranges.forEach(function (item) {
              return ranges.push(item[0]);
            });
          }
          return columns.map(function (column) {
            return {
              id: column.label,
              ranges: ranges,
              measures: [means[column.code]],
              markers: []
            };
          });
        }
        return [];
      }();
      return {
        crosstabData: crosstab,
        chartData: chart,
        summaryData: summary
      };
    }, [currentMetric, currentCrossMetric, data, currentMetricSettings]),
    crosstabData = _useMemo.crosstabData,
    chartData = _useMemo.chartData,
    summaryData = _useMemo.summaryData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, currentMetricSettings.chartType === 'bar' && /*#__PURE__*/_react["default"].createElement("div", {
    key: currentMetricSettings.visualizeAs,
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bar, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.bar), currentMetricSettings.visualizeAs === 'mean' ? {
      keys: ['mean']
    } : {
      keys: crosstabData.columns.map(function (column) {
        return column.label;
      }),
      indexBy: 'label',
      labelSkipHeight: 0,
      // Show zero value if there is no data
      label: function label(d) {
        if (Object.keys(d.data).length > 1) {
          return d.value > 0 ? d.value : '';
        }
        return /*#__PURE__*/_react["default"].createElement("tspan", {
          y: "-12"
        }, d.value);
      },
      labelTextColor: function labelTextColor(item) {
        var value = item.data.value;
        var color = (0, _color["default"])(item.color).hsl();
        var lightness = color.color[2];
        var newLightness = lightness > 60 ? Math.min(lightness - 60, 20) : 100;
        if (value === 0 && newLightness > 80) {
          newLightness = 20;
        }
        return color.lightness(newLightness).hex();
      }
    })
  })), currentMetricSettings.chartType === 'line' && /*#__PURE__*/_react["default"].createElement("div", {
    key: currentMetricSettings.visualizeAs,
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Line, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.line), {}, {
      keys: ['mean']
    })
  })), currentMetricSettings.chartType === 'bullet' && /*#__PURE__*/_react["default"].createElement("div", {
    key: currentMetricSettings.visualizeAs,
    style: {
      height: "".concat(chartData.length * 90, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bullet, {
    data: chartData,
    settings: currentMetricSettings.nivoOptions.bullet
  })), currentMetricSettings.showTable || currentMetricSettings.showSummaryStats ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tables
  }, currentMetricSettings.showTable ? /*#__PURE__*/_react["default"].createElement(_CrosstabTable["default"], {
    data: crosstabData
  }) : null, currentMetricSettings.showSummaryStats ? /*#__PURE__*/_react["default"].createElement(_CrosstabSummaryTable["default"], {
    data: summaryData
  }) : null) : null);
};
Content.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentCrossMetric: _propTypes["default"].object,
  data: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object
};
var _default = exports["default"] = Content;